import conciergeMain from '../views/concierge/conciergeMain'
import myCouponDTL from '../views/concierge/myCouponDTL'
import giftCoupon from '../views/concierge/giftCoupon'
import conciergeSendGift from '../views/concierge/conciergeSendGift'

export default [
  
  {
    path: '/concierge/conciergeMain',
    name: '/concierge/conciergeMain',
    component: conciergeMain
  },
  {
    path: '/concierge/myCouponDTL',
    name: '/concierge/myCouponDTL',
    props: true,
    component: myCouponDTL
  },
  {
    path: '/concierge/giftCoupon/:cpNo',
    name: '/concierge/giftCoupon',
    component: giftCoupon
  },
  {
    path: '/concierge/conciergeSendGift',
    name: '/concierge/conciergeSendGift',
    component: conciergeSendGift,
    props: true
  },
]


// WEBPACK FOOTER //
// ./src/router/concierge.js